<template>
  <nav class="flex flex-row justify-between items-center bg-lightgray px-4">
    <router-link class="icon" to="/">
      <i class="bdg-icon dial icon-image" />
      <p class="icon-text">dashboard</p>
    </router-link>

    <router-link class="icon" to="/projects">
      <i class="bdg-icon grass icon-image" />
      <p class="icon-text">projects</p>
    </router-link>

    <router-link class="icon" to="/contacts">
      <i class="bdg-icon contacts icon-image" />
      <p class="icon-text">contacts</p>
    </router-link>

    <router-link class="icon" to="/search">
      <i class="bdg-icon search icon-image" />
      <p class="icon-text">search</p>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "BdgFooter"
};
</script>

<style lang="scss" scoped>
.icon {
  @apply flex flex-col justify-between items-center;

  .icon-image {
    @apply block leading-none text-blue text-2xl;
  }

  .icon-text {
    @apply capitalize text-black text-xs font-light;
  }
}
</style>
